import { render, staticRenderFns } from "./ViewLogisticsModal.vue?vue&type=template&id=403b1444&scoped=true"
import script from "./ViewLogisticsModal.vue?vue&type=script&lang=js"
export * from "./ViewLogisticsModal.vue?vue&type=script&lang=js"
import style0 from "./ViewLogisticsModal.vue?vue&type=style&index=0&id=403b1444&prod&lang=less&scoped=true"
import style1 from "./ViewLogisticsModal.vue?vue&type=style&index=1&id=403b1444&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "403b1444",
  null
  
)

export default component.exports